module.exports = __webpack_public_path__ + "static/media/ga.b3cd314e.webp";